/*global Ybug*/
/*eslint no-undef: "error"*/
import Vue from 'vue'

const isProduction = process.env.VUE_APP_ENV_NAME === 'production'
const isInIframe = () => {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}
export default {
  install: function(vue, router, store) {
    if (isProduction || isInIframe()) return
    let injectYbug
    const id = 'dfhxabwmxb5q3ndbztxk'
    window.ybug_settings = { id, launcher_position: 'left-middle' }

    const setIdentity = async user => {
      if (!user) return //tood: any deIntentify with posthog
      await injectYbug
      const { email, first_name, last_name, id, practice } = user
      if (id) {
        Ybug?.setUser({
          id,
          version: process.env.VUE_APP_VERSION,
          email,
          practice
        })
        window.ybug_settings = {
          ...window.ybug_settings,
          feedback: {
            ...window.ybug_settings.feedback,
            email
          }
        }
      }
    }
    store.watch(
      state => state.auth.user,
      (user, oldUser) => {
        const isOldUser = !!Object.keys(oldUser).length
        const isNewUser = !!Object.keys(user).length
        const isLogout = isOldUser && !isNewUser
        if ((isOldUser && isNewUser && oldUser.id != user.id) || isLogout) {
          //reset
        }
        setIdentity(user)
      }
    )

    injectYbug = new Promise((resolve, reject) => {
      var ybug = document.createElement('script')
      ybug.type = 'text/javascript'
      ybug.async = true
      ybug.src = `https://widget.ybug.io/button/${id}.js`
      ybug.onload = resolve
      ybug.onerror = reject
      document.head.appendChild(ybug)
    })
  }
}
